<template>
    <div>
        <div class="block with-errors" >
            <div class="title">
                <IconBirth height="20" classes="settings-icon vertical-center" />
                <div>{{ $t('birth') }}</div>
                <div class="change" @click="edit" v-if="! editing">{{ $t('change') }}</div>
            </div>
            <div class="value" v-if="! editing" @click="edit">
                {{ user.birth ? time.substring(0,10) : $t('notSet') }}
                <sup v-if="! user.birth" class="ml-1 text-xs text-prime-500">●</sup>
            </div>
            <div class="bottom">
                <div class="input-item" :class="{ error : hasError('birthtime') }" v-if="editing">
                    <label>{{ $t('datetime') }}</label>
                    <input type="text" id="edit-time" 
                        v-model="time" :placeholder="$t('datetimePlaceholder')"
                        @focusout="unedit">
                </div>
                <div class="error-text" v-if="hasError('birthtime')">
                    {{ $t('errors.' + getError('birthtime')) }}
                </div>
                <div class="input-item" :class="{ error : hasError('birthcity') }" v-if="editing">
                    <label>{{ $t('city') }}</label>
                    <input type="text" id="edit-city" 
                        v-model="value"  :placeholder="$t('cityPlaceholder')"
                        @keyup="complete"
                        @focusout="unedit">
                    <div class="autocomplete" :class="{invisible: ! completion}">
                        <div class="list" v-if="cities.length">
                            <div class="item" v-for="(city, index) in cities" :key="city.name" @click="select(index)">
                                {{ city.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error-text" v-if="hasError('birthcity')">
                    {{ $t('errors.' + getError('birthcity')) }}
                </div>
                <SaveButton :editing="editing" @save="save" />
            </div>
        </div>
    </div>
</template>

<script>
import SaveButton from '@/components/visual/SaveButton'
import IconBirth from '@/components/visual/icons/IconBirth'
import { mapState, mapGetters } from 'vuex'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'

export default {
    components: { SaveButton, IconBirth },
    mixins: [TimeFormatMixin],
    data() {
        return {
            editing: false,
            stopEditing: false,
            completion: false,
            value: '',
            time: '',
            selected: false,
        }
    },
    created() {
        if (this.user.birth) {
            this.value = this.user.birth.name
            this.time = this.user.birth.local
        }
    },
    methods: {
        complete(event) {
            this.completion = true
            this.selected = false
            this.$store.dispatch('city/complete', event.target.value)
        },
        select(index) {
            this.selected = true
            this.$store.dispatch('city/select', index)
                .then(() => {
                    this.editing = true
                    this.stopEditing = false
                    this.completion = false
                    this.value = this.city.manual.name
                    document.getElementById('edit-city').focus()
                })
        },
        edit() {
            this.editing = true
            this.stopEditing = false
            this.completion = true
            this.$store.dispatch('city/complete', this.value)
            setTimeout(() => { document.getElementById('edit-city').focus() }, 10)
        },
        unedit() {
            this.stopEditing = true

            setTimeout(() => {
                if (! this.stopEditing) 
                    return

                var active = document.activeElement.id
                if (active != 'edit-city' && active != 'edit-time') {
                    this.editing = false 
                    this.completion = false
                } else {
                    if (active == 'edit-time')
                        this.completion = false
                    else
                        this.completion = true
                }
            }, 500)
        },
        save() {
            this.$store.dispatch('errors/clear')
            if (this.user.birth && this.value == this.user.birth.name && this.time == this.user.birth.local)
                return
            var birth = { birthtime: this.time }
            if (! this.user.birth || this.city.manual.name && this.city.manual.name == this.value)
                birth = {...birth,                     
                    birthcity: this.city.manual.name, 
                    placeid: this.city.manual.placeid, 
                }
            this.$store.dispatch('auth/saveBirth', birth)
                .then(() => {
                    if (this.hasError('birthcity') || this.hasError('placeid') || this.hasError('birthtime')) 
                        this.edit()
                    else {
                        this.selected = false
                        this.unedit()
                        this.$store.dispatch('message/show' , this.$t('birthSaved'))
                        this.$store.dispatch('predictions/reloadData')
                    }
                })
        },
    },
    computed: {
        ...mapGetters('errors', {
            hasError: 'has',
            getError: 'getFirst',
        }),
        ...mapState('auth', ['user']),
        ...mapState('city', ['city', 'cities'])
    }
}
</script>

<i18n locale="ru" lang="yaml">
  birth: "Данные рождения"
  datetime: "Дата и время рождения"
  datetimePlaceholder: "ДД.ММ.ГГГГ ЧЧ.ММ"
  city: "Город рождения"
  cityPlaceholder: "Начните вводить и выберите из списка"
  birthSaved: "Время и место рождения сохранены."
  change: "Изменить"
  notSet: "Не указаны"
  errors:
    birthcity:
        required: "Обязательно выберите город"
    birthtime:
        required: "Обязательно укажите время рождения"
        date_format: "Введите время рождения в формате ДД.ММ.ГГГГ ЧЧ:ММ"
</i18n>

<i18n locale="en" lang="yaml">
  birth: "Birth data"
  datetime: "Date and time of birth"
  datetimePlaceholder: "DD.MM.YYYY HH:MM"
  city: "City of birth"
  cityPlaceholder: "Start typing and select from list"
  birthSaved: "Birthday and birth place saved."
  change: "Change"
  notSet: "Not set"
  errors:
    birthcity:
        required: "City required"
    birthtime:
        required: "Datetime required"
        date_format: "Enter birth time in format DD.MM.YYYY HH:MM"
</i18n>
